import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { QuantityUnit } from '@web/shared/module/measurement';
import { WarehouseProductOwnerResponse } from './warehouse-product-owner.response';
import { WarehouseProductType } from '../../enums/warehouse-product-type';

@jsonObject
export class WarehouseReceiptProductCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(Number)
  public readonly quantity!: number;

  @jsonMember(String)
  public readonly quantityUnit!: QuantityUnit;

  @jsonMember(String)
  public readonly sku!: string;

  @jsonMember(String)
  public readonly type!: WarehouseProductType;

  @jsonMember(String)
  public readonly batch!: string;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly durabilityInformation!: string;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(String)
  public readonly brand!: string;

  @jsonMember(Boolean)
  public readonly promotion!: boolean;

  @jsonMember(WarehouseProductOwnerResponse)
  public readonly owner!: WarehouseProductOwnerResponse;
}
